import { useTranslation } from "react-i18next";
import { useJobRoleDetailsContext } from "../../../../components/JobRoleDetailsTree/JobRoleDetails";
import { Row } from "react-bootstrap";

export default function TechAreaIntrestHelper({
  searchObject,
  onChange,
  candidateInteresrtTechAreas,
  candidateInterestTechRoles,
  setHelperOpen
}) {
  const { t } = useTranslation();
  //const { setHelperOpen } = useJobRoleDetailsContext();
  return (
    <Row>
      <div className="col-md-6">
        <legend className="fontsize-legend">
          {t("Tech Area Interest")}{" "}
          <a
            className="col text-end"
            href="#"
            onClick={() => setHelperOpen(true)}
          >
            {t("View Categorization")}
          </a>
        </legend>{" "}
        <select
          className="form-select fontsize-legend"
          name="candidateInterestTechAreaId"
          id="candidateInterestTechAreaId"
          onChange={onChange}
          value={searchObject.candidateInterestTechAreaId || ""}
        >
          <option></option>
          {candidateInteresrtTechAreas?.map((candidateInteresrtTechArea) => (
            <option
              className="fontsize-legend"
              key={candidateInteresrtTechArea.id}
              value={candidateInteresrtTechArea.id}
            >
              {t(candidateInteresrtTechArea.description)}
            </option>
          ))}
        </select>
      </div>
      <div className="col-md-6">
        <legend className="fontsize-legend">{t("Tech Role Interest")}</legend>{" "}
        <select
          className="form-select fontsize-legend"
          name="candidateInterestTechRoleId"
          id="candidateInterestTechRoleId"
          onChange={onChange}
          value={searchObject.candidateInterestTechRoleId || ""}
        >
          <option></option>
          {candidateInterestTechRoles?.map((candidateInterestTechRole) => (
            <option
              className="fontsize-legend"
              key={candidateInterestTechRole.id}
              value={candidateInterestTechRole.id}
            >
              {t(candidateInterestTechRole.description)}
            </option>
          ))}
        </select>
      </div>
    </Row>
  );
}
